var items = {
  "block.minecraft.air": "luft",
  "block.minecraft.stone": "sten",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "polerad granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "polerad diorit",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "polerad andesit",
  "block.minecraft.grass_block": "gräsblock",
  "block.minecraft.dirt": "jord",
  "block.minecraft.coarse_dirt": "grusig jord",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "karmosinnycel",
  "block.minecraft.warped_nylium": "förvrängd nycel",
  "block.minecraft.cobblestone": "kullersten",
  "block.minecraft.oak_planks": "ekplankor",
  "block.minecraft.spruce_planks": "granplankor",
  "block.minecraft.birch_planks": "björkplankor",
  "block.minecraft.jungle_planks": "djungelplankor",
  "block.minecraft.acacia_planks": "akaciaplankor",
  "block.minecraft.dark_oak_planks": "mörka ekplankor",
  "block.minecraft.crimson_planks": "karmosinplankor",
  "block.minecraft.warped_planks": "förvrängda plankor",
  "block.minecraft.oak_sapling": "ekplanta",
  "block.minecraft.spruce_sapling": "granplanta",
  "block.minecraft.birch_sapling": "björkplanta",
  "block.minecraft.jungle_sapling": "djungelplanta",
  "block.minecraft.acacia_sapling": "akaciaplanta",
  "block.minecraft.dark_oak_sapling": "mörk ekplanta",
  "block.minecraft.bedrock": "berggrund",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "röd sand",
  "block.minecraft.gravel": "grus",
  "block.minecraft.gold_ore": "guldmalm",
  "block.minecraft.iron_ore": "järnmalm",
  "block.minecraft.coal_ore": "kolmalm",
  "block.minecraft.nether_gold_ore": "netherguldmalm",
  "block.minecraft.oak_log": "ekstam",
  "block.minecraft.spruce_log": "granstam",
  "block.minecraft.birch_log": "björkstam",
  "block.minecraft.jungle_log": "djungelträdstam",
  "block.minecraft.acacia_log": "akaciastam",
  "block.minecraft.dark_oak_log": "mörk ekstam",
  "block.minecraft.crimson_stem": "karmosinstam",
  "block.minecraft.warped_stem": "förvrängd stam",
  "block.minecraft.stripped_oak_log": "avbarkad ekstam",
  "block.minecraft.stripped_spruce_log": "avbarkad granstam",
  "block.minecraft.stripped_birch_log": "avbarkad björkstam",
  "block.minecraft.stripped_jungle_log": "avbarkad djungelträdstam",
  "block.minecraft.stripped_acacia_log": "avbarkad akaciastam",
  "block.minecraft.stripped_dark_oak_log": "avbarkad mörk ekstam",
  "block.minecraft.stripped_crimson_stem": "avbarkad karmosinstam",
  "block.minecraft.stripped_warped_stem": "avbarkad förvrängd stam",
  "block.minecraft.stripped_oak_wood": "avbarkat ekträ",
  "block.minecraft.stripped_spruce_wood": "avbarkat granträ",
  "block.minecraft.stripped_birch_wood": "avbarkat björkträ",
  "block.minecraft.stripped_jungle_wood": "avbarkat djungelträ",
  "block.minecraft.stripped_acacia_wood": "avbarkat akaciaträ",
  "block.minecraft.stripped_dark_oak_wood": "avbarkat mörkt ekträ",
  "block.minecraft.stripped_crimson_hyphae": "avbarkade karmosinhyfer",
  "block.minecraft.stripped_warped_hyphae": "avbarkade förvrängda hyfer",
  "block.minecraft.oak_wood": "ekträ",
  "block.minecraft.spruce_wood": "granträ",
  "block.minecraft.birch_wood": "björkträ",
  "block.minecraft.jungle_wood": "djungelträ",
  "block.minecraft.acacia_wood": "akaciaträ",
  "block.minecraft.dark_oak_wood": "mörkt ekträ",
  "block.minecraft.crimson_hyphae": "karmosinhyfer",
  "block.minecraft.warped_hyphae": "förvrängda hyfer",
  "block.minecraft.oak_leaves": "eklöv",
  "block.minecraft.spruce_leaves": "granbarr",
  "block.minecraft.birch_leaves": "björklöv",
  "block.minecraft.jungle_leaves": "djungellöv",
  "block.minecraft.acacia_leaves": "akacialöv",
  "block.minecraft.dark_oak_leaves": "mörka eklöv",
  "block.minecraft.sponge": "svamp",
  "block.minecraft.wet_sponge": "våt svamp",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "lapis lazulimalm",
  "block.minecraft.lapis_block": "lapis lazuliblock",
  "block.minecraft.dispenser": "automat",
  "block.minecraft.sandstone": "sandsten",
  "block.minecraft.chiseled_sandstone": "mejslad sandsten",
  "block.minecraft.cut_sandstone": "skuren sandsten",
  "block.minecraft.note_block": "notblock",
  "block.minecraft.powered_rail": "krafträls",
  "block.minecraft.detector_rail": "sensorräls",
  "block.minecraft.sticky_piston": "klibbig kolv",
  "block.minecraft.cobweb": "spindelnät",
  "block.minecraft.grass": "gräs",
  "block.minecraft.fern": "ormbunke",
  "block.minecraft.dead_bush": "död buske",
  "block.minecraft.seagrass": "sjögräs",
  "block.minecraft.sea_pickle": "havsgurka",
  "block.minecraft.piston": "kolv",
  "block.minecraft.white_wool": "vit ull",
  "block.minecraft.orange_wool": "orange ull",
  "block.minecraft.magenta_wool": "ljuslila ull",
  "block.minecraft.light_blue_wool": "ljusblå ull",
  "block.minecraft.yellow_wool": "gul ull",
  "block.minecraft.lime_wool": "limegrön ull",
  "block.minecraft.pink_wool": "rosa ull",
  "block.minecraft.gray_wool": "grå ull",
  "block.minecraft.light_gray_wool": "ljusgrå ull",
  "block.minecraft.cyan_wool": "turkos ull",
  "block.minecraft.purple_wool": "lila ull",
  "block.minecraft.blue_wool": "blå ull",
  "block.minecraft.brown_wool": "brun ull",
  "block.minecraft.green_wool": "grön ull",
  "block.minecraft.red_wool": "röd ull",
  "block.minecraft.black_wool": "svart ull",
  "block.minecraft.dandelion": "maskros",
  "block.minecraft.poppy": "vallmo",
  "block.minecraft.blue_orchid": "blå orkidé",
  "block.minecraft.allium": "gräslök",
  "block.minecraft.azure_bluet": "porslinsstjärna",
  "block.minecraft.red_tulip": "röd tulpan",
  "block.minecraft.orange_tulip": "orange tulpan",
  "block.minecraft.white_tulip": "vit tulpan",
  "block.minecraft.pink_tulip": "rosa tulpan",
  "block.minecraft.oxeye_daisy": "prästkrage",
  "block.minecraft.cornflower": "blåklint",
  "block.minecraft.lily_of_the_valley": "liljekonvalj",
  "block.minecraft.wither_rose": "witherros",
  "block.minecraft.brown_mushroom": "brun svamp",
  "block.minecraft.red_mushroom": "röd svamp",
  "block.minecraft.crimson_fungus": "karmosinsvamp",
  "block.minecraft.warped_fungus": "förvrängd svamp",
  "block.minecraft.crimson_roots": "karmosinrötter",
  "block.minecraft.warped_roots": "förvrängda rötter",
  "block.minecraft.nether_sprouts": "netherskott",
  "block.minecraft.weeping_vines": "tårklätterväxt",
  "block.minecraft.twisting_vines": "vridande klätterväxt",
  "block.minecraft.sugar_cane": "sockerrör",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "bambu",
  "block.minecraft.gold_block": "guldblock",
  "block.minecraft.iron_block": "järnblock",
  "block.minecraft.oak_slab": "ekplatta",
  "block.minecraft.spruce_slab": "granplatta",
  "block.minecraft.birch_slab": "björkplatta",
  "block.minecraft.jungle_slab": "djungelplatta",
  "block.minecraft.acacia_slab": "akaciaplatta",
  "block.minecraft.dark_oak_slab": "mörk ekplatta",
  "block.minecraft.crimson_slab": "karmosinplatta",
  "block.minecraft.warped_slab": "förvrängd platta",
  "block.minecraft.stone_slab": "stenplatta",
  "block.minecraft.smooth_stone_slab": "len stenplatta",
  "block.minecraft.sandstone_slab": "sandstensplatta",
  "block.minecraft.cut_sandstone_slab": "skuren sandstensplatta",
  "block.minecraft.petrified_oak_slab": "förstenad ekplatta",
  "block.minecraft.cobblestone_slab": "kullerstensplatta",
  "block.minecraft.brick_slab": "tegelplatta",
  "block.minecraft.stone_brick_slab": "murstensplatta",
  "block.minecraft.nether_brick_slab": "nethertegelplatta",
  "block.minecraft.quartz_slab": "kvartsplatta",
  "block.minecraft.red_sandstone_slab": "röd sandstensplatta",
  "block.minecraft.cut_red_sandstone_slab": "skuren röd sandstensplatta",
  "block.minecraft.purpur_slab": "purpurplatta",
  "block.minecraft.prismarine_slab": "prismarinplatta",
  "block.minecraft.prismarine_brick_slab": "prismarinmurstensplatta",
  "block.minecraft.dark_prismarine_slab": "mörk prismarinplatta",
  "block.minecraft.smooth_quartz": "lent kvartsblock",
  "block.minecraft.smooth_red_sandstone": "len röd sandsten",
  "block.minecraft.smooth_sandstone": "len sandsten",
  "block.minecraft.smooth_stone": "len sten",
  "block.minecraft.bricks": "tegel",
  "block.minecraft.tnt": "dynamit",
  "block.minecraft.bookshelf": "bokhylla",
  "block.minecraft.mossy_cobblestone": "mossig kullersten",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "fackla",
  "block.minecraft.end_rod": "endstav",
  "block.minecraft.chorus_plant": "körplanta",
  "block.minecraft.chorus_flower": "körblomma",
  "block.minecraft.purpur_block": "purpurblock",
  "block.minecraft.purpur_pillar": "purpurpelare",
  "block.minecraft.purpur_stairs": "purpurtrappa",
  "block.minecraft.spawner": "monsterskapare",
  "block.minecraft.oak_stairs": "ektrappa",
  "block.minecraft.chest": "kista",
  "block.minecraft.diamond_ore": "diamantmalm",
  "block.minecraft.diamond_block": "diamantblock",
  "block.minecraft.crafting_table": "arbetsbänk",
  "block.minecraft.farmland": "åkerjord",
  "block.minecraft.furnace": "ugn",
  "block.minecraft.ladder": "stege",
  "block.minecraft.rail": "räls",
  "block.minecraft.cobblestone_stairs": "kullerstenstrappa",
  "block.minecraft.lever": "spak",
  "block.minecraft.stone_pressure_plate": "stentryckplatta",
  "block.minecraft.oak_pressure_plate": "ektryckplatta",
  "block.minecraft.spruce_pressure_plate": "grantryckplatta",
  "block.minecraft.birch_pressure_plate": "björktryckplatta",
  "block.minecraft.jungle_pressure_plate": "djungeltryckplatta",
  "block.minecraft.acacia_pressure_plate": "akaciatryckplatta",
  "block.minecraft.dark_oak_pressure_plate": "mörk ektryckplatta",
  "block.minecraft.crimson_pressure_plate": "karmosintryckplatta",
  "block.minecraft.warped_pressure_plate": "förvrängd tryckplatta",
  "block.minecraft.polished_blackstone_pressure_plate": "polerad svartstenstryckplatta",
  "block.minecraft.redstone_ore": "redstonemalm",
  "block.minecraft.redstone_torch": "redstonefackla",
  "block.minecraft.snow": "snö",
  "block.minecraft.ice": "is",
  "block.minecraft.snow_block": "snöblock",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "lera",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "ekstaket",
  "block.minecraft.spruce_fence": "granstaket",
  "block.minecraft.birch_fence": "björkstaket",
  "block.minecraft.jungle_fence": "djungelstaket",
  "block.minecraft.acacia_fence": "akaciastaket",
  "block.minecraft.dark_oak_fence": "mörkt ekstaket",
  "block.minecraft.crimson_fence": "karmosinstaket",
  "block.minecraft.warped_fence": "förvrängt staket",
  "block.minecraft.pumpkin": "pumpa",
  "block.minecraft.carved_pumpkin": "skuren pumpa",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "själsand",
  "block.minecraft.soul_soil": "själjord",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polerad basalt",
  "block.minecraft.soul_torch": "själfackla",
  "block.minecraft.glowstone": "glödsten",
  "block.minecraft.jack_o_lantern": "pumpalykta",
  "block.minecraft.oak_trapdoor": "ekfallucka",
  "block.minecraft.spruce_trapdoor": "granfallucka",
  "block.minecraft.birch_trapdoor": "björkfallucka",
  "block.minecraft.jungle_trapdoor": "djungelfallucka",
  "block.minecraft.acacia_trapdoor": "akaciafallucka",
  "block.minecraft.dark_oak_trapdoor": "mörk ekfallucka",
  "block.minecraft.crimson_trapdoor": "karmosinfallucka",
  "block.minecraft.warped_trapdoor": "förvrängd fallucka",
  "block.minecraft.infested_stone": "angripen sten",
  "block.minecraft.infested_cobblestone": "angripen kullersten",
  "block.minecraft.infested_stone_bricks": "angripen mursten",
  "block.minecraft.infested_mossy_stone_bricks": "angripen mossig mursten",
  "block.minecraft.infested_cracked_stone_bricks": "angripen sprucken mursten",
  "block.minecraft.infested_chiseled_stone_bricks": "angripen mejslad mursten",
  "block.minecraft.stone_bricks": "mursten",
  "block.minecraft.mossy_stone_bricks": "mossig mursten",
  "block.minecraft.cracked_stone_bricks": "sprucken mursten",
  "block.minecraft.chiseled_stone_bricks": "mejslad mursten",
  "block.minecraft.brown_mushroom_block": "brunt svampblock",
  "block.minecraft.red_mushroom_block": "rött svampblock",
  "block.minecraft.mushroom_stem": "svampfot",
  "block.minecraft.iron_bars": "järngaller",
  "block.minecraft.chain": "kedja",
  "block.minecraft.glass_pane": "glasruta",
  "block.minecraft.melon": "melon",
  "block.minecraft.vine": "klätterväxt",
  "block.minecraft.oak_fence_gate": "ekgrind",
  "block.minecraft.spruce_fence_gate": "grangrind",
  "block.minecraft.birch_fence_gate": "björkgrind",
  "block.minecraft.jungle_fence_gate": "djungelgrind",
  "block.minecraft.acacia_fence_gate": "akaciagrind",
  "block.minecraft.dark_oak_fence_gate": "mörk ekgrind",
  "block.minecraft.crimson_fence_gate": "karmosingrind",
  "block.minecraft.warped_fence_gate": "förvrängd grind",
  "block.minecraft.brick_stairs": "tegeltrappa",
  "block.minecraft.stone_brick_stairs": "murstenstrappa",
  "block.minecraft.mycelium": "mycel",
  "block.minecraft.lily_pad": "näckrosblad",
  "block.minecraft.nether_bricks": "nethertegel",
  "block.minecraft.cracked_nether_bricks": "sprucket nethertegel",
  "block.minecraft.chiseled_nether_bricks": "mejslat nethertegel",
  "block.minecraft.nether_brick_fence": "nethertegelstaket",
  "block.minecraft.nether_brick_stairs": "nethertegeltrappa",
  "block.minecraft.enchanting_table": "förtrollningsbord",
  "block.minecraft.end_portal_frame": "endportalsram",
  "block.minecraft.end_stone": "endsten",
  "block.minecraft.end_stone_bricks": "endmursten",
  "block.minecraft.dragon_egg": "drakägg",
  "block.minecraft.redstone_lamp": "redstonelampa",
  "block.minecraft.sandstone_stairs": "sandstenstrappa",
  "block.minecraft.emerald_ore": "smaragdmalm",
  "block.minecraft.ender_chest": "enderkista",
  "block.minecraft.tripwire_hook": "snubbeltrådskrok",
  "block.minecraft.emerald_block": "smaragdblock",
  "block.minecraft.spruce_stairs": "grantrappa",
  "block.minecraft.birch_stairs": "björktrappa",
  "block.minecraft.jungle_stairs": "djungeltrappa",
  "block.minecraft.crimson_stairs": "karmosintrappa",
  "block.minecraft.warped_stairs": "förvrängd trappa",
  "block.minecraft.command_block": "kommandoblock",
  "block.minecraft.beacon": "fyr",
  "block.minecraft.cobblestone_wall": "kullerstensmur",
  "block.minecraft.mossy_cobblestone_wall": "mossig kullerstensmur",
  "block.minecraft.brick_wall": "tegelmur",
  "block.minecraft.prismarine_wall": "prismarinmur",
  "block.minecraft.red_sandstone_wall": "röd sandstensmur",
  "block.minecraft.mossy_stone_brick_wall": "mossig murstensmur",
  "block.minecraft.granite_wall": "granitmur",
  "block.minecraft.stone_brick_wall": "murstensmur",
  "block.minecraft.nether_brick_wall": "nethertegelmur",
  "block.minecraft.andesite_wall": "andesitmur",
  "block.minecraft.red_nether_brick_wall": "röd nethertegelmur",
  "block.minecraft.sandstone_wall": "sandstensmur",
  "block.minecraft.end_stone_brick_wall": "endmurstensmur",
  "block.minecraft.diorite_wall": "dioritmur",
  "block.minecraft.blackstone_wall": "svartstensmur",
  "block.minecraft.polished_blackstone_wall": "polerad svartstensmur",
  "block.minecraft.polished_blackstone_brick_wall": "polerad svartmurstensmur",
  "block.minecraft.stone_button": "stenknapp",
  "block.minecraft.oak_button": "ekknapp",
  "block.minecraft.spruce_button": "granknapp",
  "block.minecraft.birch_button": "björkknapp",
  "block.minecraft.jungle_button": "djungelknapp",
  "block.minecraft.acacia_button": "akaciaknapp",
  "block.minecraft.dark_oak_button": "mörk ekknapp",
  "block.minecraft.crimson_button": "karmosinknapp",
  "block.minecraft.warped_button": "förvrängd knapp",
  "block.minecraft.polished_blackstone_button": "polerad svartstensknapp",
  "block.minecraft.anvil": "städ",
  "block.minecraft.chipped_anvil": "sprucket städ",
  "block.minecraft.damaged_anvil": "skadat städ",
  "block.minecraft.trapped_chest": "kistfälla",
  "block.minecraft.light_weighted_pressure_plate": "lätt tyngdtryckplatta",
  "block.minecraft.heavy_weighted_pressure_plate": "tung tyngdtryckplatta",
  "block.minecraft.daylight_detector": "dagsljusdetektor",
  "block.minecraft.redstone_block": "redstoneblock",
  "block.minecraft.nether_quartz_ore": "netherkvartsmalm",
  "block.minecraft.hopper": "tratt",
  "block.minecraft.chiseled_quartz_block": "mejslat kvartsblock",
  "block.minecraft.quartz_block": "kvartsblock",
  "block.minecraft.quartz_bricks": "kvartsmursten",
  "block.minecraft.quartz_pillar": "kvartspelare",
  "block.minecraft.quartz_stairs": "kvartstrappa",
  "block.minecraft.activator_rail": "aktiveringsräls",
  "block.minecraft.dropper": "utmatare",
  "block.minecraft.white_terracotta": "vit terrakotta",
  "block.minecraft.orange_terracotta": "orange terrakotta",
  "block.minecraft.magenta_terracotta": "ljuslila terrakotta",
  "block.minecraft.light_blue_terracotta": "ljusblå terrakotta",
  "block.minecraft.yellow_terracotta": "gul terrakotta",
  "block.minecraft.lime_terracotta": "limegrön terrakotta",
  "block.minecraft.pink_terracotta": "rosa terrakotta",
  "block.minecraft.gray_terracotta": "grå terrakotta",
  "block.minecraft.light_gray_terracotta": "ljusgrå terrakotta",
  "block.minecraft.cyan_terracotta": "turkos terrakotta",
  "block.minecraft.purple_terracotta": "lila terrakotta",
  "block.minecraft.blue_terracotta": "blå terrakotta",
  "block.minecraft.brown_terracotta": "brun terrakotta",
  "block.minecraft.green_terracotta": "grön terrakotta",
  "block.minecraft.red_terracotta": "röd terrakotta",
  "block.minecraft.black_terracotta": "svart terrakotta",
  "block.minecraft.barrier": "barriär",
  "block.minecraft.iron_trapdoor": "järnfallucka",
  "block.minecraft.hay_block": "höbal",
  "block.minecraft.white_carpet": "vit matta",
  "block.minecraft.orange_carpet": "orange matta",
  "block.minecraft.magenta_carpet": "ljuslila matta",
  "block.minecraft.light_blue_carpet": "ljusblå matta",
  "block.minecraft.yellow_carpet": "gul matta",
  "block.minecraft.lime_carpet": "limegrön matta",
  "block.minecraft.pink_carpet": "rosa matta",
  "block.minecraft.gray_carpet": "grå matta",
  "block.minecraft.light_gray_carpet": "ljusgrå matta",
  "block.minecraft.cyan_carpet": "turkos matta",
  "block.minecraft.purple_carpet": "lila matta",
  "block.minecraft.blue_carpet": "blå matta",
  "block.minecraft.brown_carpet": "brun matta",
  "block.minecraft.green_carpet": "grön matta",
  "block.minecraft.red_carpet": "röd matta",
  "block.minecraft.black_carpet": "svart matta",
  "block.minecraft.terracotta": "terrakotta",
  "block.minecraft.coal_block": "kolblock",
  "block.minecraft.packed_ice": "packad is",
  "block.minecraft.acacia_stairs": "akaciatrappa",
  "block.minecraft.dark_oak_stairs": "mörk ektrappa",
  "block.minecraft.slime_block": "slemblock",
  "block.minecraft.grass_path": "grässtig",
  "block.minecraft.sunflower": "solros",
  "block.minecraft.lilac": "syren",
  "block.minecraft.rose_bush": "rosbuske",
  "block.minecraft.peony": "pion",
  "block.minecraft.tall_grass": "högt gräs",
  "block.minecraft.large_fern": "stor ormbunke",
  "block.minecraft.white_stained_glass": "vitfärgat glas",
  "block.minecraft.orange_stained_glass": "orangefärgat glas",
  "block.minecraft.magenta_stained_glass": "ljuslilafärgat glas",
  "block.minecraft.light_blue_stained_glass": "ljusblåfärgat glas",
  "block.minecraft.yellow_stained_glass": "gulfärgat glas",
  "block.minecraft.lime_stained_glass": "limegrönfärgat glas",
  "block.minecraft.pink_stained_glass": "rosafärgat glas",
  "block.minecraft.gray_stained_glass": "gråfärgat glas",
  "block.minecraft.light_gray_stained_glass": "ljusgråfärgat glas",
  "block.minecraft.cyan_stained_glass": "turkosfärgat glas",
  "block.minecraft.purple_stained_glass": "lilafärgat glas",
  "block.minecraft.blue_stained_glass": "blåfärgat glas",
  "block.minecraft.brown_stained_glass": "brunfärgat glas",
  "block.minecraft.green_stained_glass": "grönfärgat glas",
  "block.minecraft.red_stained_glass": "rödfärgat glas",
  "block.minecraft.black_stained_glass": "svartfärgat glas",
  "block.minecraft.white_stained_glass_pane": "vitfärgad glasruta",
  "block.minecraft.orange_stained_glass_pane": "orangefärgad glasruta",
  "block.minecraft.magenta_stained_glass_pane": "ljuslilafärgad glasruta",
  "block.minecraft.light_blue_stained_glass_pane": "ljusblåfärgad glasruta",
  "block.minecraft.yellow_stained_glass_pane": "gulfärgad glasruta",
  "block.minecraft.lime_stained_glass_pane": "limegrönfärgad glasruta",
  "block.minecraft.pink_stained_glass_pane": "rosafärgad glasruta",
  "block.minecraft.gray_stained_glass_pane": "gråfärgad glasruta",
  "block.minecraft.light_gray_stained_glass_pane": "ljusgråfärgad glasruta",
  "block.minecraft.cyan_stained_glass_pane": "turkosfärgad glasruta",
  "block.minecraft.purple_stained_glass_pane": "lilafärgad glasruta",
  "block.minecraft.blue_stained_glass_pane": "blåfärgad glasruta",
  "block.minecraft.brown_stained_glass_pane": "brunfärgad glasruta",
  "block.minecraft.green_stained_glass_pane": "grönfärgad glasruta",
  "block.minecraft.red_stained_glass_pane": "rödfärgad glasruta",
  "block.minecraft.black_stained_glass_pane": "svartfärgad glasruta",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "prismarinmursten",
  "block.minecraft.dark_prismarine": "mörk prismarin",
  "block.minecraft.prismarine_stairs": "prismarintrappa",
  "block.minecraft.prismarine_brick_stairs": "prismarinmurstenstrappa",
  "block.minecraft.dark_prismarine_stairs": "mörk prismarintrappa",
  "block.minecraft.sea_lantern": "havslykta",
  "block.minecraft.red_sandstone": "röd sandsten",
  "block.minecraft.chiseled_red_sandstone": "mejslad röd sandsten",
  "block.minecraft.cut_red_sandstone": "skuren röd sandsten",
  "block.minecraft.red_sandstone_stairs": "röd sandstenstrappa",
  "block.minecraft.repeating_command_block": "upprepande kommandoblock",
  "block.minecraft.chain_command_block": "kedjat kommandoblock",
  "block.minecraft.magma_block": "magmablock",
  "block.minecraft.nether_wart_block": "nethervårtsblock",
  "block.minecraft.warped_wart_block": "förvrängt vårtblock",
  "block.minecraft.red_nether_bricks": "rött nethertegel",
  "block.minecraft.bone_block": "benblock",
  "block.minecraft.structure_void": "strukturtomrum",
  "block.minecraft.observer": "observatör",
  "block.minecraft.shulker_box": "shulkerlåda",
  "block.minecraft.white_shulker_box": "vit shulkerlåda",
  "block.minecraft.orange_shulker_box": "orange shulkerlåda",
  "block.minecraft.magenta_shulker_box": "ljuslila shulkerlåda",
  "block.minecraft.light_blue_shulker_box": "ljusblå shulkerlåda",
  "block.minecraft.yellow_shulker_box": "gul shulkerlåda",
  "block.minecraft.lime_shulker_box": "limegrön shulkerlåda",
  "block.minecraft.pink_shulker_box": "rosa shulkerlåda",
  "block.minecraft.gray_shulker_box": "grå shulkerlåda",
  "block.minecraft.light_gray_shulker_box": "ljusgrå shulkerlåda",
  "block.minecraft.cyan_shulker_box": "turkos shulkerlåda",
  "block.minecraft.purple_shulker_box": "lila shulkerlåda",
  "block.minecraft.blue_shulker_box": "blå shulkerlåda",
  "block.minecraft.brown_shulker_box": "brun shulkerlåda",
  "block.minecraft.green_shulker_box": "grön shulkerlåda",
  "block.minecraft.red_shulker_box": "röd shulkerlåda",
  "block.minecraft.black_shulker_box": "svart shulkerlåda",
  "block.minecraft.white_glazed_terracotta": "vitglaserad terrakotta",
  "block.minecraft.orange_glazed_terracotta": "orangeglaserad terrakotta",
  "block.minecraft.magenta_glazed_terracotta": "ljuslilaglaserad terrakotta",
  "block.minecraft.light_blue_glazed_terracotta": "ljusblåglaserad terrakotta",
  "block.minecraft.yellow_glazed_terracotta": "gulglaserad terrakotta",
  "block.minecraft.lime_glazed_terracotta": "limegrönglaserad terrakotta",
  "block.minecraft.pink_glazed_terracotta": "rosaglaserad terrakotta",
  "block.minecraft.gray_glazed_terracotta": "gråglaserad terrakotta",
  "block.minecraft.light_gray_glazed_terracotta": "ljusgråglaserad terrakotta",
  "block.minecraft.cyan_glazed_terracotta": "turkosglaserad terrakotta",
  "block.minecraft.purple_glazed_terracotta": "lilaglaserad terrakotta",
  "block.minecraft.blue_glazed_terracotta": "blåglaserad terrakotta",
  "block.minecraft.brown_glazed_terracotta": "brunglaserad terrakotta",
  "block.minecraft.green_glazed_terracotta": "grönglaserad terrakotta",
  "block.minecraft.red_glazed_terracotta": "rödglaserad terrakotta",
  "block.minecraft.black_glazed_terracotta": "svartglaserad terrakotta",
  "block.minecraft.white_concrete": "vit betong",
  "block.minecraft.orange_concrete": "orange betong",
  "block.minecraft.magenta_concrete": "ljuslila betong",
  "block.minecraft.light_blue_concrete": "ljusblå betong",
  "block.minecraft.yellow_concrete": "gul betong",
  "block.minecraft.lime_concrete": "limegrön betong",
  "block.minecraft.pink_concrete": "rosa betong",
  "block.minecraft.gray_concrete": "grå betong",
  "block.minecraft.light_gray_concrete": "ljusgrå betong",
  "block.minecraft.cyan_concrete": "turkos betong",
  "block.minecraft.purple_concrete": "lila betong",
  "block.minecraft.blue_concrete": "blå betong",
  "block.minecraft.brown_concrete": "brun betong",
  "block.minecraft.green_concrete": "grön betong",
  "block.minecraft.red_concrete": "röd betong",
  "block.minecraft.black_concrete": "svart betong",
  "block.minecraft.white_concrete_powder": "vitt betongpulver",
  "block.minecraft.orange_concrete_powder": "orange betongpulver",
  "block.minecraft.magenta_concrete_powder": "ljuslila betongpulver",
  "block.minecraft.light_blue_concrete_powder": "ljusblått betongpulver",
  "block.minecraft.yellow_concrete_powder": "gult betongpulver",
  "block.minecraft.lime_concrete_powder": "limegrönt betongpulver",
  "block.minecraft.pink_concrete_powder": "rosa betongpulver",
  "block.minecraft.gray_concrete_powder": "grått betongpulver",
  "block.minecraft.light_gray_concrete_powder": "ljusgrått betongpulver",
  "block.minecraft.cyan_concrete_powder": "turkost betongpulver",
  "block.minecraft.purple_concrete_powder": "lila betongpulver",
  "block.minecraft.blue_concrete_powder": "blått betongpulver",
  "block.minecraft.brown_concrete_powder": "brunt betongpulver",
  "block.minecraft.green_concrete_powder": "grönt betongpulver",
  "block.minecraft.red_concrete_powder": "rött betongpulver",
  "block.minecraft.black_concrete_powder": "svart betongpulver",
  "block.minecraft.turtle_egg": "sköldpaddsägg",
  "block.minecraft.dead_tube_coral_block": "dött orgelkorallblock",
  "block.minecraft.dead_brain_coral_block": "dött hjärnkorallblock",
  "block.minecraft.dead_bubble_coral_block": "dött bubbelkorallblock",
  "block.minecraft.dead_fire_coral_block": "dött eldkorallblock",
  "block.minecraft.dead_horn_coral_block": "dött hornkorallblock",
  "block.minecraft.tube_coral_block": "orgelkorallblock",
  "block.minecraft.brain_coral_block": "hjärnkorallblock",
  "block.minecraft.bubble_coral_block": "bubbelkorallblock",
  "block.minecraft.fire_coral_block": "eldkorallblock",
  "block.minecraft.horn_coral_block": "hornkorallblock",
  "block.minecraft.tube_coral": "orgelkorall",
  "block.minecraft.brain_coral": "hjärnkorall",
  "block.minecraft.bubble_coral": "bubbelkorall",
  "block.minecraft.fire_coral": "eldkorall",
  "block.minecraft.horn_coral": "hornkorall",
  "block.minecraft.dead_brain_coral": "död hjärnkorall",
  "block.minecraft.dead_bubble_coral": "död bubbelkorall",
  "block.minecraft.dead_fire_coral": "död eldkorall",
  "block.minecraft.dead_horn_coral": "död hornkorall",
  "block.minecraft.dead_tube_coral": "död orgelkorall",
  "block.minecraft.tube_coral_fan": "orgelkorallfläkt",
  "block.minecraft.brain_coral_fan": "hjärnkorallfläkt",
  "block.minecraft.bubble_coral_fan": "bubbelkorallfläkt",
  "block.minecraft.fire_coral_fan": "eldkorallfläkt",
  "block.minecraft.horn_coral_fan": "hornkorallfläkt",
  "block.minecraft.dead_tube_coral_fan": "död orgelkorallfläkt",
  "block.minecraft.dead_brain_coral_fan": "död hjärnkorallfläkt",
  "block.minecraft.dead_bubble_coral_fan": "död bubbelkorallfläkt",
  "block.minecraft.dead_fire_coral_fan": "död eldkorallfläkt",
  "block.minecraft.dead_horn_coral_fan": "död hornkorallfläkt",
  "block.minecraft.blue_ice": "blå is",
  "block.minecraft.conduit": "flödare",
  "block.minecraft.polished_granite_stairs": "polerad granittrappa",
  "block.minecraft.smooth_red_sandstone_stairs": "len röd sandstenstrappa",
  "block.minecraft.mossy_stone_brick_stairs": "mossig murstenstrappa",
  "block.minecraft.polished_diorite_stairs": "polerad diorittrappa",
  "block.minecraft.mossy_cobblestone_stairs": "mossig kullerstenstrappa",
  "block.minecraft.end_stone_brick_stairs": "endmurstenstrappa",
  "block.minecraft.stone_stairs": "stentrappa",
  "block.minecraft.smooth_sandstone_stairs": "len sandstenstrappa",
  "block.minecraft.smooth_quartz_stairs": "len kvartstrappa",
  "block.minecraft.granite_stairs": "granittrappa",
  "block.minecraft.andesite_stairs": "andesittrappa",
  "block.minecraft.red_nether_brick_stairs": "röd nethertegeltrappa",
  "block.minecraft.polished_andesite_stairs": "polerad andesittrappa",
  "block.minecraft.diorite_stairs": "diorittrappa",
  "block.minecraft.polished_granite_slab": "polerad granitplatta",
  "block.minecraft.smooth_red_sandstone_slab": "len röd sandstensplatta",
  "block.minecraft.mossy_stone_brick_slab": "mossig murstensplatta",
  "block.minecraft.polished_diorite_slab": "polerad dioritplatta",
  "block.minecraft.mossy_cobblestone_slab": "mossig kullerstensplatta",
  "block.minecraft.end_stone_brick_slab": "endmurstensplatta",
  "block.minecraft.smooth_sandstone_slab": "len sandstensplatta",
  "block.minecraft.smooth_quartz_slab": "len kvartsplatta",
  "block.minecraft.granite_slab": "granitplatta",
  "block.minecraft.andesite_slab": "andesitplatta",
  "block.minecraft.red_nether_brick_slab": "röd nethertegelplatta",
  "block.minecraft.polished_andesite_slab": "polerad andesitplatta",
  "block.minecraft.diorite_slab": "dioritplatta",
  "block.minecraft.scaffolding": "byggnadsställning",
  "block.minecraft.iron_door": "järndörr",
  "block.minecraft.oak_door": "ekdörr",
  "block.minecraft.spruce_door": "grandörr",
  "block.minecraft.birch_door": "björkdörr",
  "block.minecraft.jungle_door": "djungeldörr",
  "block.minecraft.acacia_door": "akaciadörr",
  "block.minecraft.dark_oak_door": "mörk ekdörr",
  "block.minecraft.crimson_door": "karmosindörr",
  "block.minecraft.warped_door": "förvrängd dörr",
  "block.minecraft.repeater": "redstonerepeterare",
  "block.minecraft.comparator": "redstonejämförare",
  "block.minecraft.structure_block": "strukturblock",
  "block.minecraft.jigsaw": "pusselbitsblock",
  "item.minecraft.turtle_helmet": "sköldpaddsskal□□på huvudet:□+2 rustning",
  "item.minecraft.scute": "skal",
  "item.minecraft.iron_shovel": "järnspade□□i primära handen:□+3.5 attackskada□-3 attackhastighet",
  "item.minecraft.iron_pickaxe": "järnhacka□□i primära handen:□+3 attackskada□-2.8 attackhastighet",
  "item.minecraft.iron_axe": "järnyxa□□i primära handen:□+8 attackskada□-3.1 attackhastighet",
  "item.minecraft.flint_and_steel": "tändstål",
  "item.minecraft.apple": "äpple",
  "item.minecraft.bow": "pilbåge",
  "item.minecraft.arrow": "pil",
  "item.minecraft.coal": "kol",
  "item.minecraft.charcoal": "träkol",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "järntacka",
  "item.minecraft.gold_ingot": "guldtacka",
  "item.minecraft.netherite_ingot": "netherittacka",
  "item.minecraft.netherite_scrap": "netheritstycke",
  "item.minecraft.iron_sword": "järnsvärd□□i primära handen:□+5 attackskada□-2.4 attackhastighet",
  "item.minecraft.wooden_sword": "träsvärd□□i primära handen:□+3 attackskada□-2.4 attackhastighet",
  "item.minecraft.wooden_shovel": "träspade□□i primära handen:□+1.5 attackskada□-3 attackhastighet",
  "item.minecraft.wooden_pickaxe": "trähacka□□i primära handen:□+1 attackskada□-2.8 attackhastighet",
  "item.minecraft.wooden_axe": "träyxa□□i primära handen:□+6 attackskada□-3.2 attackhastighet",
  "item.minecraft.stone_sword": "stensvärd□□i primära handen:□+4 attackskada□-2.4 attackhastighet",
  "item.minecraft.stone_shovel": "stenspade□□i primära handen:□+2.5 attackskada□-3 attackhastighet",
  "item.minecraft.stone_pickaxe": "stenhacka□□i primära handen:□+2 attackskada□-2.8 attackhastighet",
  "item.minecraft.stone_axe": "stenyxa□□i primära handen:□+8 attackskada□-3.2 attackhastighet",
  "item.minecraft.diamond_sword": "diamantsvärd□□i primära handen:□+6 attackskada□-2.4 attackhastighet",
  "item.minecraft.diamond_shovel": "diamantspade□□i primära handen:□+4.5 attackskada□-3 attackhastighet",
  "item.minecraft.diamond_pickaxe": "diamanthacka□□i primära handen:□+4 attackskada□-2.8 attackhastighet",
  "item.minecraft.diamond_axe": "diamantyxa□□i primära handen:□+8 attackskada□-3 attackhastighet",
  "item.minecraft.stick": "pinne",
  "item.minecraft.bowl": "skål",
  "item.minecraft.mushroom_stew": "svampstuvning",
  "item.minecraft.golden_sword": "guldsvärd□□i primära handen:□+3 attackskada□-2.4 attackhastighet",
  "item.minecraft.golden_shovel": "guldspade□□i primära handen:□+1.5 attackskada□-3 attackhastighet",
  "item.minecraft.golden_pickaxe": "guldhacka□□i primära handen:□+1 attackskada□-2.8 attackhastighet",
  "item.minecraft.golden_axe": "guldyxa□□i primära handen:□+6 attackskada□-3 attackhastighet",
  "item.minecraft.netherite_sword": "netheritsvärd□□i primära handen:□+7 attackskada□-2.4 attackhastighet",
  "item.minecraft.netherite_shovel": "netheritspade□□i primära handen:□+5.5 attackskada□-3 attackhastighet",
  "item.minecraft.netherite_pickaxe": "netherithacka□□i primära handen:□+5 attackskada□-2.8 attackhastighet",
  "item.minecraft.netherite_axe": "netherityxa□□i primära handen:□+9 attackskada□-3 attackhastighet",
  "item.minecraft.string": "tråd",
  "item.minecraft.feather": "fjäder",
  "item.minecraft.gunpowder": "krut",
  "item.minecraft.wooden_hoe": "träflåhacka□□i primära handen:□-3 attackhastighet",
  "item.minecraft.stone_hoe": "stenflåhacka□□i primära handen:□-2 attackhastighet",
  "item.minecraft.iron_hoe": "järnflåhacka□□i primära handen:□-1 attackhastighet",
  "item.minecraft.diamond_hoe": "diamantflåhacka□□i primära handen:",
  "item.minecraft.golden_hoe": "guldflåhacka□□i primära handen:□-3 attackhastighet",
  "item.minecraft.netherite_hoe": "netheritflåhacka□□i primära handen:",
  "item.minecraft.wheat_seeds": "vetefrön",
  "item.minecraft.wheat": "vete",
  "item.minecraft.bread": "bröd",
  "item.minecraft.leather_helmet": "lädermössa□□på huvudet:□+1 rustning",
  "item.minecraft.leather_chestplate": "lädertunika□□på kroppen:□+3 rustning",
  "item.minecraft.leather_leggings": "läderbyxor□□på benen:□+2 rustning",
  "item.minecraft.leather_boots": "läderstövlar□□på fötterna:□+1 rustning",
  "item.minecraft.chainmail_helmet": "ringbrynjehuva□□på huvudet:□+2 rustning",
  "item.minecraft.chainmail_chestplate": "ringbrynjeskjorta□□på kroppen:□+5 rustning",
  "item.minecraft.chainmail_leggings": "ringbrynjebyxor□□på benen:□+4 rustning",
  "item.minecraft.chainmail_boots": "ringbrynjestövlar□□på fötterna:□+1 rustning",
  "item.minecraft.iron_helmet": "järnhjälm□□på huvudet:□+2 rustning",
  "item.minecraft.iron_chestplate": "järnharnesk□□på kroppen:□+6 rustning",
  "item.minecraft.iron_leggings": "järnbyxor□□på benen:□+5 rustning",
  "item.minecraft.iron_boots": "järnstövlar□□på fötterna:□+2 rustning",
  "item.minecraft.diamond_helmet": "diamanthjälm□□på huvudet:□+3 rustning□+2 rustningshårdhet",
  "item.minecraft.diamond_chestplate": "diamantharnesk□□på kroppen:□+8 rustning□+2 rustningshårdhet",
  "item.minecraft.diamond_leggings": "diamantbyxor□□på benen:□+6 rustning□+2 rustningshårdhet",
  "item.minecraft.diamond_boots": "diamantstövlar□□på fötterna:□+3 rustning□+2 rustningshårdhet",
  "item.minecraft.golden_helmet": "guldhjälm□□på huvudet:□+2 rustning",
  "item.minecraft.golden_chestplate": "guldharnesk□□på kroppen:□+5 rustning",
  "item.minecraft.golden_leggings": "guldbyxor□□på benen:□+3 rustning",
  "item.minecraft.golden_boots": "guldstövlar□□på fötterna:□+1 rustning",
  "item.minecraft.netherite_helmet": "netherithjälm□□på huvudet:□+3 rustning□+3 rustningshårdhet□+1 knuffresistans",
  "item.minecraft.netherite_chestplate": "netheritharnesk□□på kroppen:□+8 rustning□+3 rustningshårdhet□+1 knuffresistans",
  "item.minecraft.netherite_leggings": "netheritbyxor□□på benen:□+6 rustning□+3 rustningshårdhet□+1 knuffresistans",
  "item.minecraft.netherite_boots": "netheritstövlar□□på fötterna:□+3 rustning□+3 rustningshårdhet□+1 knuffresistans",
  "item.minecraft.flint": "flinta",
  "item.minecraft.porkchop": "rå fläskkotlett",
  "item.minecraft.cooked_porkchop": "tillagad fläskkotlett",
  "item.minecraft.painting": "tavla",
  "item.minecraft.golden_apple": "guldäpple",
  "item.minecraft.enchanted_golden_apple": "förtrollat guldäpple",
  "block.minecraft.oak_sign": "ekskylt",
  "block.minecraft.spruce_sign": "granskylt",
  "block.minecraft.birch_sign": "björkskylt",
  "block.minecraft.jungle_sign": "djungelskylt",
  "block.minecraft.acacia_sign": "akaciaskylt",
  "block.minecraft.dark_oak_sign": "mörk ekskylt",
  "block.minecraft.crimson_sign": "karmosinskylt",
  "block.minecraft.warped_sign": "förvrängd skylt",
  "item.minecraft.bucket": "hink",
  "item.minecraft.water_bucket": "vattenhink",
  "item.minecraft.lava_bucket": "lavahink",
  "item.minecraft.minecart": "gruvvagn",
  "item.minecraft.saddle": "sadel",
  "item.minecraft.redstone": "redstonedamm",
  "item.minecraft.snowball": "snöboll",
  "item.minecraft.oak_boat": "ekbåt",
  "item.minecraft.leather": "läder",
  "item.minecraft.milk_bucket": "mjölkhink",
  "item.minecraft.pufferfish_bucket": "hink med blåsfisk",
  "item.minecraft.salmon_bucket": "hink med lax",
  "item.minecraft.cod_bucket": "hink med torsk",
  "item.minecraft.tropical_fish_bucket": "hink med tropisk fisk",
  "item.minecraft.brick": "tegelsten",
  "item.minecraft.clay_ball": "lerboll",
  "block.minecraft.dried_kelp_block": "torkat kelpblock",
  "item.minecraft.paper": "papper",
  "item.minecraft.book": "bok",
  "item.minecraft.slime_ball": "slemboll",
  "item.minecraft.chest_minecart": "gruvvagn med kista",
  "item.minecraft.furnace_minecart": "gruvvagn med ugn",
  "item.minecraft.egg": "ägg",
  "item.minecraft.compass": "kompass",
  "item.minecraft.fishing_rod": "fiskespö",
  "item.minecraft.clock": "klocka",
  "item.minecraft.glowstone_dust": "glödstensdamm",
  "item.minecraft.cod": "rå torsk",
  "item.minecraft.salmon": "rå lax",
  "item.minecraft.tropical_fish": "tropisk fisk",
  "item.minecraft.pufferfish": "blåsfisk",
  "item.minecraft.cooked_cod": "tillagad torsk",
  "item.minecraft.cooked_salmon": "tillagad lax",
  "item.minecraft.ink_sac": "bläcksäck",
  "item.minecraft.red_dye": "röd färg",
  "item.minecraft.green_dye": "grön färg",
  "item.minecraft.cocoa_beans": "kakaobönor",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "lila färg",
  "item.minecraft.cyan_dye": "turkos färg",
  "item.minecraft.light_gray_dye": "ljusgrå färg",
  "item.minecraft.gray_dye": "grå färg",
  "item.minecraft.pink_dye": "rosa färg",
  "item.minecraft.lime_dye": "limegrön färg",
  "item.minecraft.yellow_dye": "gul färg",
  "item.minecraft.light_blue_dye": "ljusblå färg",
  "item.minecraft.magenta_dye": "ljuslila färg",
  "item.minecraft.orange_dye": "orange färg",
  "item.minecraft.bone_meal": "benmjöl",
  "item.minecraft.blue_dye": "blå färg",
  "item.minecraft.brown_dye": "brun färg",
  "item.minecraft.black_dye": "svart färg",
  "item.minecraft.white_dye": "vit färg",
  "item.minecraft.bone": "ben",
  "item.minecraft.sugar": "socker",
  "block.minecraft.cake": "tårta",
  "block.minecraft.white_bed": "vit säng",
  "block.minecraft.orange_bed": "orange säng",
  "block.minecraft.magenta_bed": "ljuslila säng",
  "block.minecraft.light_blue_bed": "ljusblå säng",
  "block.minecraft.yellow_bed": "gul säng",
  "block.minecraft.lime_bed": "limegrön säng",
  "block.minecraft.pink_bed": "rosa säng",
  "block.minecraft.gray_bed": "grå säng",
  "block.minecraft.light_gray_bed": "ljusgrå säng",
  "block.minecraft.cyan_bed": "turkos säng",
  "block.minecraft.purple_bed": "lila säng",
  "block.minecraft.blue_bed": "blå säng",
  "block.minecraft.brown_bed": "brun säng",
  "block.minecraft.green_bed": "grön säng",
  "block.minecraft.red_bed": "röd säng",
  "block.minecraft.black_bed": "svart säng",
  "item.minecraft.cookie": "kaka",
  "item.minecraft.filled_map": "karta□#0",
  "item.minecraft.shears": "sax",
  "item.minecraft.melon_slice": "melonskiva",
  "item.minecraft.dried_kelp": "torkad kelp",
  "item.minecraft.pumpkin_seeds": "pumpafrön",
  "item.minecraft.melon_seeds": "melonfrön",
  "item.minecraft.beef": "rå biff",
  "item.minecraft.cooked_beef": "tillagad biff",
  "item.minecraft.chicken": "rå kyckling",
  "item.minecraft.cooked_chicken": "tillagad kyckling",
  "item.minecraft.rotten_flesh": "ruttet kött",
  "item.minecraft.ender_pearl": "enderpärla",
  "item.minecraft.blaze_rod": "brännstav",
  "item.minecraft.ghast_tear": "ghasttår",
  "item.minecraft.gold_nugget": "guldklimp",
  "item.minecraft.nether_wart": "nethervårta",
  "item.minecraft.potion": "icke-tillverkningsbar brygd□inga effekter",
  "item.minecraft.glass_bottle": "glasflaska",
  "item.minecraft.spider_eye": "spindelöga",
  "item.minecraft.fermented_spider_eye": "jäst spindelöga",
  "item.minecraft.blaze_powder": "brännpulver",
  "item.minecraft.magma_cream": "magmakräm",
  "block.minecraft.brewing_stand": "brygdställ",
  "block.minecraft.cauldron": "kittel",
  "item.minecraft.ender_eye": "enderöga",
  "item.minecraft.glistering_melon_slice": "gnistrande melonskiva",
  "item.minecraft.bat_spawn_egg": "skapelseägg för fladdermus",
  "item.minecraft.bee_spawn_egg": "skapelseägg för bi",
  "item.minecraft.blaze_spawn_egg": "skapelseägg för brännare",
  "item.minecraft.cat_spawn_egg": "skapelseägg för katt",
  "item.minecraft.cave_spider_spawn_egg": "skapelseägg för grottspindel",
  "item.minecraft.chicken_spawn_egg": "skapelseägg för höna",
  "item.minecraft.cod_spawn_egg": "skapelseägg för torsk",
  "item.minecraft.cow_spawn_egg": "skapelseägg för ko",
  "item.minecraft.creeper_spawn_egg": "skapelseägg för creeper",
  "item.minecraft.dolphin_spawn_egg": "skapelseägg för delfin",
  "item.minecraft.donkey_spawn_egg": "skapelseägg för åsna",
  "item.minecraft.drowned_spawn_egg": "skapelseägg för drunknad zombie",
  "item.minecraft.elder_guardian_spawn_egg": "skapelseägg för urväktare",
  "item.minecraft.enderman_spawn_egg": "skapelseägg för enderman",
  "item.minecraft.endermite_spawn_egg": "skapelseägg för endermite",
  "item.minecraft.evoker_spawn_egg": "skapelseägg för frammanare",
  "item.minecraft.fox_spawn_egg": "skapelseägg för räv",
  "item.minecraft.ghast_spawn_egg": "skapelseägg för ghast",
  "item.minecraft.guardian_spawn_egg": "skapelseägg för väktare",
  "item.minecraft.hoglin_spawn_egg": "skapelseägg för hoglin",
  "item.minecraft.horse_spawn_egg": "skapelseägg för häst",
  "item.minecraft.husk_spawn_egg": "skapelseägg för uttorkad zombie",
  "item.minecraft.llama_spawn_egg": "skapelseägg för lama",
  "item.minecraft.magma_cube_spawn_egg": "skapelseägg för magmakub",
  "item.minecraft.mooshroom_spawn_egg": "skapelseägg för mooshroom",
  "item.minecraft.mule_spawn_egg": "skapelseägg för mula",
  "item.minecraft.ocelot_spawn_egg": "skapelseägg för ozelot",
  "item.minecraft.panda_spawn_egg": "skapelseägg för panda",
  "item.minecraft.parrot_spawn_egg": "skapelseägg för papegoja",
  "item.minecraft.phantom_spawn_egg": "skapelseägg för fantom",
  "item.minecraft.pig_spawn_egg": "skapelseägg för gris",
  "item.minecraft.piglin_spawn_egg": "skapelseägg för piglin",
  "item.minecraft.pillager_spawn_egg": "skapelseägg för plundrare",
  "item.minecraft.polar_bear_spawn_egg": "skapelseägg för isbjörn",
  "item.minecraft.pufferfish_spawn_egg": "skapelseägg för blåsfisk",
  "item.minecraft.rabbit_spawn_egg": "skapelseägg för kanin",
  "item.minecraft.ravager_spawn_egg": "skapelseägg för ödeläggare",
  "item.minecraft.salmon_spawn_egg": "skapelseägg för lax",
  "item.minecraft.sheep_spawn_egg": "skapelseägg för får",
  "item.minecraft.shulker_spawn_egg": "skapelseägg för shulker",
  "item.minecraft.silverfish_spawn_egg": "skapelseägg för silverfisk",
  "item.minecraft.skeleton_spawn_egg": "skapelseägg för skelett",
  "item.minecraft.skeleton_horse_spawn_egg": "skapelseägg för skeletthäst",
  "item.minecraft.slime_spawn_egg": "skapelseägg för slemkub",
  "item.minecraft.spider_spawn_egg": "skapelseägg för spindel",
  "item.minecraft.squid_spawn_egg": "skapelseägg för bläckfisk",
  "item.minecraft.stray_spawn_egg": "skapelseägg för strövare",
  "item.minecraft.strider_spawn_egg": "skapelseägg för vandrare",
  "item.minecraft.trader_llama_spawn_egg": "skapelseägg för byteshandlarlama",
  "item.minecraft.tropical_fish_spawn_egg": "skapelseägg för tropisk fisk",
  "item.minecraft.turtle_spawn_egg": "skapelseägg för sköldpadda",
  "item.minecraft.vex_spawn_egg": "skapelseägg för osalig ande",
  "item.minecraft.villager_spawn_egg": "skapelseägg för bybo",
  "item.minecraft.vindicator_spawn_egg": "skapelseägg för försvarare",
  "item.minecraft.wandering_trader_spawn_egg": "skapelseägg för vandrande byteshandlare",
  "item.minecraft.witch_spawn_egg": "skapelseägg för häxa",
  "item.minecraft.wither_skeleton_spawn_egg": "skapelseägg för witherskelett",
  "item.minecraft.wolf_spawn_egg": "skapelseägg för varg",
  "item.minecraft.zoglin_spawn_egg": "skapelseägg för zoglin",
  "item.minecraft.zombie_spawn_egg": "skapelseägg för zombie",
  "item.minecraft.zombie_horse_spawn_egg": "skapelseägg för zombiehäst",
  "item.minecraft.zombie_villager_spawn_egg": "skapelseägg för zombiebybo",
  "item.minecraft.zombified_piglin_spawn_egg": "skapelseägg för zombifierad piglin",
  "item.minecraft.experience_bottle": "förtrollningsflaska",
  "item.minecraft.fire_charge": "eldladdning",
  "item.minecraft.writable_book": "bok och fjäderpenna",
  "item.minecraft.written_book": "skriven bok",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "föremålsram",
  "block.minecraft.flower_pot": "blomkruka",
  "item.minecraft.carrot": "morot",
  "item.minecraft.potato": "potatis",
  "item.minecraft.baked_potato": "bakad potatis",
  "item.minecraft.poisonous_potato": "giftig potatis",
  "item.minecraft.map": "tom karta",
  "item.minecraft.golden_carrot": "gyllene morot",
  "block.minecraft.skeleton_skull": "skelettskalle",
  "block.minecraft.wither_skeleton_skull": "witherskelettskalle",
  "block.minecraft.player_head": "spelarhuvud",
  "block.minecraft.zombie_head": "zombiehuvud",
  "block.minecraft.creeper_head": "creeperhuvud",
  "block.minecraft.dragon_head": "drakhuvud",
  "item.minecraft.carrot_on_a_stick": "morot på pinne",
  "item.minecraft.warped_fungus_on_a_stick": "förvrängd svamp på pinne",
  "item.minecraft.nether_star": "netherstjärna",
  "item.minecraft.pumpkin_pie": "pumpapaj",
  "item.minecraft.firework_rocket": "fyrverkeriraket",
  "item.minecraft.firework_star": "fyrverkeristjärna",
  "item.minecraft.enchanted_book": "förtrollad bok",
  "item.minecraft.nether_brick": "nethertegelsten",
  "item.minecraft.quartz": "netherkvarts",
  "item.minecraft.tnt_minecart": "gruvvagn med dynamit",
  "item.minecraft.hopper_minecart": "gruvvagn med tratt",
  "item.minecraft.prismarine_shard": "prismarinskärva",
  "item.minecraft.prismarine_crystals": "prismarinkristaller",
  "item.minecraft.rabbit": "rå kanin",
  "item.minecraft.cooked_rabbit": "tillagad kanin",
  "item.minecraft.rabbit_stew": "kaninstuvning",
  "item.minecraft.rabbit_foot": "hartass",
  "item.minecraft.rabbit_hide": "kaninskinn",
  "item.minecraft.armor_stand": "rustningsställ",
  "item.minecraft.iron_horse_armor": "järnhästrustning",
  "item.minecraft.golden_horse_armor": "guldhästrustning",
  "item.minecraft.diamond_horse_armor": "diamanthästrustning",
  "item.minecraft.leather_horse_armor": "läderhästrustning",
  "item.minecraft.lead": "koppel",
  "item.minecraft.name_tag": "namnskylt",
  "item.minecraft.command_block_minecart": "gruvvagn med kommandoblock",
  "item.minecraft.mutton": "rått fårkött",
  "item.minecraft.cooked_mutton": "tillagat fårkött",
  "block.minecraft.white_banner": "vit fana",
  "block.minecraft.orange_banner": "orange fana",
  "block.minecraft.magenta_banner": "ljuslila fana",
  "block.minecraft.light_blue_banner": "ljusblå fana",
  "block.minecraft.yellow_banner": "gul fana",
  "block.minecraft.lime_banner": "limegrön fana",
  "block.minecraft.pink_banner": "rosa fana",
  "block.minecraft.gray_banner": "grå fana",
  "block.minecraft.light_gray_banner": "ljusgrå fana",
  "block.minecraft.cyan_banner": "turkos fana",
  "block.minecraft.purple_banner": "lila fana",
  "block.minecraft.blue_banner": "blå fana",
  "block.minecraft.brown_banner": "brun fana",
  "block.minecraft.green_banner": "grön fana",
  "block.minecraft.red_banner": "röd fana",
  "block.minecraft.black_banner": "svart fana",
  "item.minecraft.end_crystal": "endkristall",
  "item.minecraft.chorus_fruit": "körfrukt",
  "item.minecraft.popped_chorus_fruit": "utslagen körfrukt",
  "item.minecraft.beetroot": "rödbeta",
  "item.minecraft.beetroot_seeds": "rödbetsfrön",
  "item.minecraft.beetroot_soup": "rödbetssoppa",
  "item.minecraft.dragon_breath": "drakeld",
  "item.minecraft.splash_potion": "kastbar icke-tillverkningsbar brygd□inga effekter",
  "item.minecraft.spectral_arrow": "spektralpil",
  "item.minecraft.tipped_arrow": "icke-tillverkningsbar förtrollad pil□inga effekter",
  "item.minecraft.lingering_potion": "kvardröjande icke-tillverkningsbar brygd□inga effekter",
  "item.minecraft.shield": "sköld",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "granbåt",
  "item.minecraft.birch_boat": "björkbåt",
  "item.minecraft.jungle_boat": "djungelbåt",
  "item.minecraft.acacia_boat": "akaciabåt",
  "item.minecraft.dark_oak_boat": "mörk ekbåt",
  "item.minecraft.totem_of_undying": "odödlighetstotem",
  "item.minecraft.shulker_shell": "shulkerskal",
  "item.minecraft.iron_nugget": "järnklimp",
  "item.minecraft.knowledge_book": "kunskapsbok",
  "item.minecraft.debug_stick": "felsökningspinne",
  "item.minecraft.music_disc_13": "musikskiva□c418 - 13",
  "item.minecraft.music_disc_cat": "musikskiva□c418 - cat",
  "item.minecraft.music_disc_blocks": "musikskiva□c418 - blocks",
  "item.minecraft.music_disc_chirp": "musikskiva□c418 - chirp",
  "item.minecraft.music_disc_far": "musikskiva□c418 - far",
  "item.minecraft.music_disc_mall": "musikskiva□c418 - mall",
  "item.minecraft.music_disc_mellohi": "musikskiva□c418 - mellohi",
  "item.minecraft.music_disc_stal": "musikskiva□c418 - stal",
  "item.minecraft.music_disc_strad": "musikskiva□c418 - strad",
  "item.minecraft.music_disc_ward": "musikskiva□c418 - ward",
  "item.minecraft.music_disc_11": "musikskiva□c418 - 11",
  "item.minecraft.music_disc_wait": "musikskiva□c418 - wait",
  "item.minecraft.music_disc_pigstep": "musikskiva□lena raine - pigstep",
  "item.minecraft.trident": "treudd□□i primära handen:□+8 attackskada□-2.9 attackhastighet",
  "item.minecraft.phantom_membrane": "fantommembran",
  "item.minecraft.nautilus_shell": "pärlbåtsskal",
  "item.minecraft.heart_of_the_sea": "havets hjärta",
  "item.minecraft.crossbow": "armborst",
  "item.minecraft.suspicious_stew": "misstänksam stuvning",
  "block.minecraft.loom": "vävstol",
  "item.minecraft.flower_banner_pattern": "fanemönster□blomma",
  "item.minecraft.creeper_banner_pattern": "fanemönster□creeper",
  "item.minecraft.skull_banner_pattern": "fanemönster□dödskalle",
  "item.minecraft.mojang_banner_pattern": "fanemönster□mojäng",
  "item.minecraft.globe_banner_pattern": "fanemönster□glob",
  "item.minecraft.piglin_banner_pattern": "fanemönster□tryne",
  "block.minecraft.composter": "kompost",
  "block.minecraft.barrel": "tunna",
  "block.minecraft.smoker": "rökugn",
  "block.minecraft.blast_furnace": "masugn",
  "block.minecraft.cartography_table": "kartografbord",
  "block.minecraft.fletching_table": "pilmakarbänk",
  "block.minecraft.grindstone": "slipsten",
  "block.minecraft.lectern": "läspulpet",
  "block.minecraft.smithing_table": "smedsbänk",
  "block.minecraft.stonecutter": "stenskärare",
  "block.minecraft.bell": "ringklocka",
  "block.minecraft.lantern": "lykta",
  "block.minecraft.soul_lantern": "själlykta",
  "item.minecraft.sweet_berries": "söta bär",
  "block.minecraft.campfire": "lägereld",
  "block.minecraft.soul_campfire": "själlägereld",
  "block.minecraft.shroomlight": "svampljus",
  "item.minecraft.honeycomb": "vaxkaka",
  "block.minecraft.bee_nest": "bisamhälle",
  "block.minecraft.beehive": "bikupa",
  "item.minecraft.honey_bottle": "honungsflaska",
  "block.minecraft.honey_block": "honungsblock",
  "block.minecraft.honeycomb_block": "vaxkaksblock",
  "block.minecraft.lodestone": "magnetit",
  "block.minecraft.netherite_block": "netheritblock",
  "block.minecraft.ancient_debris": "forntida spillror",
  "block.minecraft.target": "måltavla",
  "block.minecraft.crying_obsidian": "gråtande obsidian",
  "block.minecraft.blackstone": "svartsten",
  "block.minecraft.blackstone_slab": "svartstensplatta",
  "block.minecraft.blackstone_stairs": "svartstenstrappa",
  "block.minecraft.gilded_blackstone": "förgylld svartsten",
  "block.minecraft.polished_blackstone": "polerad svartsten",
  "block.minecraft.polished_blackstone_slab": "polerad svartstensplatta",
  "block.minecraft.polished_blackstone_stairs": "polerad svartstenstrappa",
  "block.minecraft.chiseled_polished_blackstone": "mejslad polerad svartsten",
  "block.minecraft.polished_blackstone_bricks": "polerad svartmursten",
  "block.minecraft.polished_blackstone_brick_slab": "polerad svartmurstensplatta",
  "block.minecraft.polished_blackstone_brick_stairs": "polerad svartmurstenstrappa",
  "block.minecraft.cracked_polished_blackstone_bricks": "sprucken polerad svartmursten",
  "block.minecraft.respawn_anchor": "återuppståndelseankare",
}
export const sv_se = items; 
